import { render, staticRenderFns } from "./PurchaseApplication.vue?vue&type=template&id=6d1172e4&scoped=true&"
import script from "./PurchaseApplication.vue?vue&type=script&lang=js&"
export * from "./PurchaseApplication.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseApplication.vue?vue&type=style&index=0&id=6d1172e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1172e4",
  null
  
)

export default component.exports